import axios from 'axios';

const API_KEY = process.env.REACT_APP_API_GATEWAY_KEY;
const API_URL =
	process.env.REACT_APP_API_URL ||
	'https://assemblie-gateway-4b3pe96q.ue.gateway.dev';

const apiClient = axios.create({
	baseURL: API_URL,
	headers: {
		'Content-Type': 'application/json',
	},
	// Add withCredentials to support cookies if needed
	withCredentials: true,
});

// Add API key to all requests
apiClient.interceptors.request.use(
	(config) => {
		// Add the API key as a query parameter
		config.params = {
			...config.params,
			key: API_KEY,
		};

		// Add authorization header if token exists
		const token = localStorage.getItem('token');
		if (token) {
			config.headers.Authorization = token;
		}

		return config;
	},
	(error) => Promise.reject(error)
);

// Add response interceptor for debugging
apiClient.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		console.error(
			`Error from ${error.config?.url}:`,
			error.response?.status,
			error.response?.data
		);

		// Special handling for CORS errors
		if (error.message === 'Network Error' && !error.response) {
			console.error('Possible CORS error - no response received');
		}

		return Promise.reject(error);
	}
);

// Add a utility function for retrying API calls
export const retryApiCall = async (apiCallFn, maxRetries = 3, delay = 1000) => {
	let lastError;

	for (let attempt = 1; attempt <= maxRetries; attempt++) {
		try {
			const result = await apiCallFn();
			return result;
		} catch (error) {
			console.error(`Attempt ${attempt} failed:`, error);
			lastError = error;

			// Don't retry if it's not a network or 401 error
			if (
				error.response &&
				![401, 408, 429, 500, 502, 503, 504].includes(
					error.response.status
				)
			) {
				throw error;
			}

			// Wait before retrying
			if (attempt < maxRetries) {
				await new Promise((resolve) => setTimeout(resolve, delay));
			}
		}
	}

	throw lastError;
};

export default apiClient;
